// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";
import "./SVGCheckmarkIcon.styl";
const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGCheckmarkIcon2 extends PureComponent {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        //fill={fill || "currentColor"}
        background-color="rgb(255,255,255)"
        style={style}
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        enableBackground="new 0 0 32 32"
      >
        <circle
          className="path circle"
          fill="rgb(4, 153, 255)"
          //stroke="#73AF55"
          stroke="rgb(4, 153, 255)"
          //stroke="rgb(255, 255, 255)"
          strokeWidth="6"
          strokeMiterlimit="10"
          cx="65.1"
          cy="65.1"
          r="62.1"
          transform="matrix(0.245776,0,0,0.245776,0,0)"
        />
        <polyline
          className="path check"
          fill="none"
          //stroke="#73AF55"
          stroke="rgb(255, 255, 255)"
          strokeWidth="20"
          strokeLinecap="round"
          strokeMiterlimit="10"
          points="100.2,40.2 51.5,88.8 29.8,67.5 "
          transform="matrix(0.245776,0,0,0.245776,0,0)"
        />
      </svg>
    );
  }
}
